import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Some general impressions of the US",
  "description": "",
  "published": "2010-11-01T00:00:00.000Z",
  "redirect_from": ["/blog/some-general-impressions-of-the-us/swizec/1472"],
  "categories": "Cheesecake Factory, Ljubljana, San Francisco, travel, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:Alcatraz_Island_Lighthouse.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/11/300px-Alcatraz_Island_Lighthouse.jpg",
              "alt": "The lighthouse on Alcatraz Island, San Francis...",
              "title": "The lighthouse on Alcatraz Island, San Francis..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/File:Alcatraz_Island_Lighthouse.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`Now that it's been a weekend since my return from `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=38.8833333333,-77.0166666667&spn=10.0,10.0&q=38.8833333333,-77.0166666667%20(United%20States)&t=h",
        "title": "United States"
      }}>{`the US`}</a>{` and I've had plenty of time to get over the cold of epic proportions that hit me on the way to the airport (literally, I was buying and popping fever reducers at the airport before boarding) and I've had plenty of time to compose myself, I can finally write down some thoughts of what I'd seen on my two week journey into the unknown.`}</p>
    <p>{`At least I thought it was the unknown. Turns out there was no `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Culture_shock",
        "title": "Culture shock"
      }}>{`culture shock`}</a>{` to speak of.`}</p>
    <p>{`Apparently if you watch enough movies and television, or just if you watch as much as I do, the US turns out to be a pretty unsurprising country to visit. I had more surprises visiting the `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=51.5,-0.116666666667&spn=10.0,10.0&q=51.5,-0.116666666667%20(United%20Kingdom)&t=h",
        "title": "United Kingdom"
      }}>{`UK`}</a>{` or `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=41.9,12.4833333333&spn=10.0,10.0&q=41.9,12.4833333333%20(Italy)&t=h",
        "title": "Italy"
      }}>{`Italy`}</a>{` and they're practically neighbours.`}</p>
    <p>{`Everything is just as you'd expect:`}</p>
    <ul>
      <li parentName="ul">{`the roads are incredibly wide`}</li>
      <li parentName="ul">{`the roads have way too many lanes`}</li>
      <li parentName="ul">{`the cars are stupidly big`}</li>
      <li parentName="ul">{`everything is insanely cheap`}</li>
    </ul>
    <p>{`That last point in particular was quite surprising. The US markets itself as the land of plenty, the land of supple opportunity and the land of the rich. Well, from a European's point of view, the US is pretty much a big `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Discount_store",
        "title": "Discount store"
      }}>{`discount store`}</a>{`. You enter the country and `}<em parentName="p">{`everything`}</em>{` is sold at roughly a 30% to 40% discount depending on the day.`}</p>
    <p>{`And the cheapening effect doesn't stop at the Dollar vs. Euro dynamic. Because of the bigger economy and cheap labor (I imagine) stuff is just cheaper in general. For example a sushi lunch in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.0513888889,14.5055555556&spn=0.1,0.1&q=46.0513888889,14.5055555556%20(Ljubljana)&t=h",
        "title": "Ljubljana"
      }}>{`Ljubljana`}</a>{` would cost three times as much as it did in the US, while being at least half smaller.`}</p>
    <p>{`It's pretty insane.`}</p>
    <p>{`Or like I bought a pair of jeans at a pretty reasonable price and upon getting home my sister tells me what I bought was one of the top brands super-expensive type of jeans. O.o`}</p>
    <p>{`Ok, so I guess there's a bit of culture shock. The cheapness of everything.`}</p>
    <p>{`There were, however, a few more odd little tidbits that I noticed:`}</p>
    <ul>
      <li parentName="ul">{`americans aren't as fat as you'd think, on average they're quite europe-like`}</li>
      <li parentName="ul">{`all doors open the wrong way (fire safety or something)`}</li>
      <li parentName="ul">{`there is a severe lack of automatic doors everywhere`}</li>
      <li parentName="ul">{`some stores still give you hand-written receipts`}</li>
      <li parentName="ul">{`very few stores have modern computer-like cash registers`}</li>
      <li parentName="ul">{`almost nobody takes `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Debit_card",
          "title": "Debit card"
        }}>{`debit cards`}</a>{` as payment`}</li>
      <li parentName="ul">{`all store clerks are SOOPER nice, it was surprising`}</li>
      <li parentName="ul">{`a lot of "natives" don't speak english`}</li>
    </ul>
    <p>{`That's about it, I should write some more about the actual startup scene, the companies we visited and what we've seen of the US from that perspective; but that's best reserved for Preona's company blog.`}</p>
    <p>{`Oh and while I did go see `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.8264,-122.4224&spn=1.0,1.0&q=37.8264,-122.4224%20(Alcatraz%20Island)&t=h",
        "title": "Alcatraz Island"
      }}>{`Alcatraz`}</a>{` and it was very fucking incredibly rainy that day, I didn't get to see the Golden Gate Bridge, which is just stupid. But anyways, here are some random pics from my shiny new iPhone4.`}</p>
    <p>{`PS: Cheesecake Factory has the best fucking cheesecake (or cake in general) that I have ever had the pleasure of tasting!`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=b11e33c7-9113-4266-9831-ea91b28c7758",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      